var _defs, _g, _g2, _path, _path2, _circle, _g3, _script;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGraphicPushFactorAuth = function SvgGraphicPushFactorAuth(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "e05fzFPmOaU1",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 252 175",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "e05fzFPmOaU2-filter",
    width: "400%",
    height: "400%",
    x: "-150%",
    y: "-150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "e05fzFPmOaU2-filter-drop-shadow-0-blur",
    in: "SourceAlpha",
    stdDeviation: "16,16"
  }), /*#__PURE__*/React.createElement("feOffset", {
    id: "e05fzFPmOaU2-filter-drop-shadow-0-offset",
    dx: 0,
    dy: -2,
    result: "tmp"
  }), /*#__PURE__*/React.createElement("feFlood", {
    id: "e05fzFPmOaU2-filter-drop-shadow-0-flood",
    floodColor: "rgba(0,145,238,0.12)"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "e05fzFPmOaU2-filter-drop-shadow-0-composite",
    in2: "tmp",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", {
    id: "e05fzFPmOaU2-filter-drop-shadow-0-merge",
    result: "result"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    id: "e05fzFPmOaU2-filter-drop-shadow-0-merge-node-1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    id: "e05fzFPmOaU2-filter-drop-shadow-0-merge-node-2",
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "e05fzFPmOaU4-filter",
    width: "400%",
    height: "400%",
    x: "-150%",
    y: "-150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "e05fzFPmOaU4-filter-drop-shadow-0-blur",
    in: "SourceAlpha",
    stdDeviation: "16,16"
  }), /*#__PURE__*/React.createElement("feOffset", {
    id: "e05fzFPmOaU4-filter-drop-shadow-0-offset",
    dx: 0,
    dy: -2,
    result: "tmp"
  }), /*#__PURE__*/React.createElement("feFlood", {
    id: "e05fzFPmOaU4-filter-drop-shadow-0-flood",
    floodColor: "rgba(0,145,238,0.12)"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "e05fzFPmOaU4-filter-drop-shadow-0-composite",
    in2: "tmp",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", {
    id: "e05fzFPmOaU4-filter-drop-shadow-0-merge",
    result: "result"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    id: "e05fzFPmOaU4-filter-drop-shadow-0-merge-node-1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    id: "e05fzFPmOaU4-filter-drop-shadow-0-merge-node-2",
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "e05fzFPmOaU11-filter",
    width: "400%",
    height: "400%",
    x: "-150%",
    y: "-150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "e05fzFPmOaU11-filter-drop-shadow-0-blur",
    in: "SourceAlpha",
    stdDeviation: "16,16"
  }), /*#__PURE__*/React.createElement("feOffset", {
    id: "e05fzFPmOaU11-filter-drop-shadow-0-offset",
    dx: 0,
    dy: -2,
    result: "tmp"
  }), /*#__PURE__*/React.createElement("feFlood", {
    id: "e05fzFPmOaU11-filter-drop-shadow-0-flood",
    floodColor: "rgba(0,145,238,0.12)"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "e05fzFPmOaU11-filter-drop-shadow-0-composite",
    in2: "tmp",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", {
    id: "e05fzFPmOaU11-filter-drop-shadow-0-merge",
    result: "result"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    id: "e05fzFPmOaU11-filter-drop-shadow-0-merge-node-1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    id: "e05fzFPmOaU11-filter-drop-shadow-0-merge-node-2",
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#e05fzFPmOaU2-filter)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M147.886 64.891c-.194 0-.386.01-.579.015l.001-.015c0-17.06-13.865-30.891-30.967-30.891-13.889 0-25.641 9.12-29.568 21.684a21.272 21.272 0 0 0-9.922-2.443c-11.78 0-21.329 9.526-21.329 21.277 0 1.914.258 3.767.733 5.532a17.216 17.216 0 0 0-6.995-1.486c-9.532 0-17.26 7.709-17.26 17.218S39.728 113 49.26 113h98.626C161.204 113 172 102.23 172 88.945s-10.796-24.054-24.114-24.054Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#e05fzFPmOaU4-filter)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M143.018 112.724c.129 0 .257.007.385.01v-.01c0-11.445 9.21-20.724 20.571-20.724 9.225 0 17.032 6.119 19.641 14.548a14.016 14.016 0 0 1 6.591-1.639c7.825 0 14.169 6.39 14.169 14.274 0 1.284-.171 2.527-.487 3.711a11.341 11.341 0 0 1 4.646-.997c6.333 0 11.466 5.172 11.466 11.552 0 6.379-5.133 11.551-11.466 11.551h-65.516c-8.846 0-16.018-7.225-16.018-16.138s7.172-16.138 16.018-16.138Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dabdff",
    d: "M101.424 57.86h49.408c3.84 0 7.168 3.072 7.168 7.168v89.856c0 3.84-3.072 7.168-7.168 7.168h-49.664c-3.84 0-7.168-3.072-7.168-7.168V65.028c.256-3.84 3.328-7.168 7.424-7.168Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0190ed",
    d: "M104.64 65.028h44.8c.512 0 1.28.255 1.792.767s.768 1.025.768 1.793v82.688c0 .512-.256 1.28-.768 1.792s-1.024.768-1.792.768h-44.8a2.294 2.294 0 0 1-2.304-2.304v-83.2c0-.512.256-1.28.768-1.792.256-.257.768-.513 1.536-.513ZM122.064 158.467h6.656c.768 0 1.28-.512 1.28-1.28s-.512-1.28-1.28-1.28h-6.656c-.768 0-1.28.512-1.28 1.28s.512 1.28 1.28 1.28Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "#fff",
    strokeWidth: 0,
    filter: "url(#e05fzFPmOaU11-filter)",
    transform: "matrix(2.49773 0 0 2.49773 173.5 81.5)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "e05fzFPmOaU12"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff4aa2",
    d: "M190.246 91.113c-1.209-.827-2.31-1.763-3.135-2.998-1.199-1.794-1.596-3.81-1.65-5.916-.038-1.5.013-3.004-.019-4.506-.066-3.188-1.304-5.861-3.627-8.033-1.042-.974-2.252-1.671-3.56-2.201-.227-1.948-1.882-3.459-3.89-3.459s-3.679 1.527-3.894 3.488c-3.246 1.236-5.439 3.572-6.639 6.936-.516 1.446-.555 2.956-.562 4.474-.008 1.696-.009 3.398-.156 5.085-.16 1.844-.911 3.491-2.097 4.924-.721.872-1.612 1.548-2.519 2.21-.214.156-.423.421-.477.67-.123.573.304.982.945.983h30.607c.127 0 .255.007.381-.005a.858.858 0 0 0 .776-.866c.003-.367-.203-.595-.483-.786h-.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e31587",
    d: "M174.364 99a5.024 5.024 0 0 0 5.024-4.99H169.34a5.024 5.024 0 0 0 5.024 4.99Z"
  }))), _script || (_script = /*#__PURE__*/React.createElement("script", null)));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicPushFactorAuth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_push_factor_auth.03d970859d70b0c2569fadb7ce1f170f.svg";